import cloneDeep from 'lodash/cloneDeep';

import {userLevels} from '../ui/helpers/constants.jsx';


class User {
  constructor({id, email, name, firstName, lastName, username, dealerId, password, passwordReset, passwordResetLink, phoneNumber,
    privileges, deleted, canWaterTest, zip, tos, video, apps, downgraded, titrationTestingOnly, locale,  region,
  }) {
    this.id = id;
    this.email = email;
    this.name = name;
    this.firstName = firstName;
    this.lastName = lastName;
    this.username = username;
    this.dealerId = dealerId;
    this.zip = zip;
    this.password = password;
    this.passwordReset = passwordReset;
    this.passwordResetLink = passwordResetLink;
    this.phoneNumber = phoneNumber;
    this.deleted = deleted;
    this.canWaterTest = canWaterTest;
    this.tos = tos;
    this.video = video;
    this.apps = apps;
    this.downgraded = downgraded;
    this.titrationTestingOnly = titrationTestingOnly;
    this.locale = locale;
    this.region = region;

    // Need to manually map this so gets deep copied
    this.privileges = Object.assign({}, privileges);
    this.privileges.branches = privileges && privileges.branches ? Object.assign([], privileges.branches) : [];
  }

  clone() {
    return cloneDeep(this);
  }

  toApiFormat() {
    return {
      ID: this.id,
      Email: this.email,
      Name: this.name,
      FirstName: this.firstName,
      LastName: this.lastName,
      Username: this.username,
      DealerID: this.dealerId,
      Password: this.password,
      PasswordReset: this.passwordReset,
      PasswordResetLinks: this.passwordResetLink,
      PhoneNumber: this.phoneNumber,
      Privileges: this.privileges,
      Deleted: this.deleted,
      CanWaterTest: this.canWaterTest,
      Zip: this.zip,
      apps: this.apps,
      Downgraded: this.downgraded,
      TitrationTestingOnly: this.titrationTestingOnly,
      Locale: this.Locale,
    };
  }

  static fromApiFormat(api) {
    return new User({
      id: api.ID,
      email: api.Email,
      name: api.Name,
      firstName: api.FirstName,
      lastName: api.LastName,
      username: api.Username,
      dealerId: api.DealerID,
      password: api.Password,
      passwordReset: api.PasswordReset,
      passwordResetLink: api.PasswordResetLink,
      phoneNumber: api.PhoneNumber,
      privileges: api.Privileges,
      deleted: api.Deleted,
      canWaterTest: api.CanWaterTest,
      zip: api.Zip,
      tos: api.tos,
      video: api.video,
      apps: api.apps,
      downgraded: api.Downgraded,
      titrationTestingOnly: api.TitrationTestingOnly,
      locale: api.Locale,
      region: api.Region,
    });
  }

  validate() {
    return this.validateName() && this.validateEmail() && this.validateUsername() && (this.isAdmin || this.privileges.branches.length === 1);
  }

  validateName() {
    return !!this.name;
  }

  validateEmail() {
    let email = this.email;

    if (!email) {
      // Only email OR username need to be filled but if there is an email it needs to be valid
      if (this.username) {
        return true;
      }
      return false;
    }

    let [address, domain] = email.split('@');

    domain = domain || '';
    let [name, extension] = domain.split('.');

    if (!address || address.length === 0 ||
      !name || name.length === 0 ||
      !extension || extension.length === 0
    ) {
      return false;
    }

    return true;
  }

  validateUsername() {
    return !!this.username || this.email;
  }

  get isTestStation() {
    if (this.privileges && this.privileges.level) {
      return this.privileges.level >= userLevels.testStation;
    }
    return true;
  }

  get isDealerAdmin() {
    if (this.privileges && this.privileges.level) {
      return this.privileges.level >= userLevels.dealerAdmin;
    }
    return false;
  }

  get isAdmin() {
    if (this.privileges && this.privileges.level) {
      return this.privileges.level >= userLevels.manager;
    }
    return false;
  }

  isBranchMember(branch) {
    return this.privileges.branches.some(b => b === branch.id);
  }

  addBranch(branch) {
    this.privileges.branches.push(branch.id);
  }

  removeBranch(branch) {
    let index = this.privileges.branches.findIndex(b => b === branch.id);

    if (index > -1) {
      this.privileges.branches.splice(index, 1);
    }
  }
}

export default User;
